import { Component, OnInit,Output,EventEmitter, OnDestroy } from '@angular/core';
import { PatientsService } from '../patients.service';
import { PregnancyService} from '../pregnancy.service';
import {ExamsService} from '../exams.service';
import { Patient } from '../patients/patient';
import { LoginService } from '../login.service';
import { SignatureService } from '../signature.service';

import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-examsbar',
    templateUrl: './examsbar.component.html',
    styleUrls: ['./examsbar.component.scss'],
    standalone: false
})
export class ExamsbarComponent implements OnInit, OnDestroy {
  @Output() pageChange = new EventEmitter<string>();
  @Output() showPatDetails = new EventEmitter();
  currentPage = "Preparation";
  showPat:boolean=false;
  sub = new Subscription()
  isBookmark =false;
  
  pat:Patient;
  constructor(
    public patservice: PatientsService, 
    private pregServ: PregnancyService, 
    public es: ExamsService, 
    private router: Router, 
    public ls: LoginService,
    public signatureService: SignatureService
  ) { }

  ngOnInit() {
    this.pat = this.patservice.getPat();
    if(this.pat.ID == 'default')
      this.currentPage = 'Placenta';
    
    if (this.ls.isUSG && this.es.ExamType !== "Abdomen US" && this.es.ExamType !== 'MSK Musculoskeletal' && this.es.ExamType !== 'MSK & Soft Tissues' && this.es.ExamType !== 'Neck scan' && this.es.ExamType !== 'Ultrasound Scan Summary' && this.es.ExamType !== 'Hemorrhoids Treatment') {
      this.currentPage = "Preparation";
    } else if (this.es.ExamType === 'Hemorrhoids Treatment') {
      this.currentPage = "Procedure Summary";
    } else if (this.es.ExamType === 'MSK Musculoskeletal') {
      this.currentPage = "MSK Musculoskeletal";
    } else if (this.es.ExamType === 'MSK & Soft Tissues') {
      this.currentPage = "MSK & Soft Tissues";
    } else if (this.es.ExamType === 'Neck scan') {
      this.currentPage = "Neck scan";
    } else if (this.es.ExamType === 'Ultrasound Scan Summary') {
      this.currentPage = "Ultrasound Scan Summary";
    } else if (this.es.ExamType === 'Endoscopy') {
      this.currentPage = "Preparation";
    } else {
      this.currentPage = "Abdomen US";
    }
    if(this.es.loadedFromLabResults){
      if(this.es.loadedFromLabResults == 'needsPayer'){
        this.currentPage = 'SummaryGastro';
      }
      else
        this.currentPage = 'Pathologies';
    }
    
    this.sub = this.es.NTAdd$.subscribe(() => {
      if(!this.es.addNT)
        this.setPage('Placenta')
    })
  }

  setPage(page:string){
    this.es.ShowSRs=false;
    this.currentPage=page;
    this.pageChange.emit(page);
  }

  showPatD(){
    this.showPatDetails.emit();
  }

  go(place:string){
    this.router.navigateByUrl(place);
    this.es.exitExam();
  }

  bookmark(){
    console.log(this.es.examID);
    this.isBookmark = !this.isBookmark
  }

  ngOnDestroy(): void {
    if(this.sub){
      this.sub.unsubscribe()
    }
  }

  handleClose(place: string) {
    const examObject = this.es.examObject;
    const isDoctor = this.es.isDoctor();
    const isExamSigned = this.signatureService.isExamSigned(examObject);
    const isClosed = this.es.isClosed;


    if (isDoctor && !isExamSigned && !isClosed) {
      this.signatureService.alertToSign$.next(true);
    } else {
      this.router.navigateByUrl(place);
      this.es.exitExam();
    }
  }

}
